import React from 'react';

type Props = {
  color: string
} | typeof defaultProps;

const defaultProps = {
  color: '#424B50',
};

const EducationBadgeIcon = function EducationBadgeIcon(props: Props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_4029_13860" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4029_13860)">
        <path d="M11.6847 6.00041C11.6133 6.00227 11.5428 6.01593 11.4759 6.04083L2.42156 9.49009C2.29782 9.53606 2.1911 9.61879 2.11575 9.72718C2.04039 9.83556 2 9.96441 2 10.0964C2 10.2284 2.04039 10.3573 2.11575 10.4656C2.1911 10.574 2.29782 10.6568 2.42156 10.7027L5.45314 11.8547V15.4859C5.45314 16.0056 5.75287 16.4483 6.12682 16.7591C6.50078 17.07 6.97284 17.2975 7.52808 17.4867C8.63857 17.8651 10.0906 18.0728 11.7049 18.0728C13.3192 18.0728 14.7713 17.8651 15.8818 17.4867C16.437 17.2975 16.9091 17.07 17.283 16.7591C17.657 16.4483 17.9567 16.0056 17.9567 15.4859V11.8547L20.9883 10.7027C21.112 10.6568 21.2187 10.574 21.2941 10.4656C21.3695 10.3573 21.4098 10.2284 21.4098 10.0964C21.4098 9.96441 21.3695 9.83556 21.2941 9.72718C21.2187 9.61879 21.112 9.53606 20.9883 9.49009L11.934 6.04083C11.8544 6.01111 11.7696 5.99738 11.6847 6.00041ZM11.7049 7.34104L18.9403 10.0964L11.7049 12.8518L4.46956 10.0964L11.7049 7.34104ZM6.74661 12.3533L11.4759 14.152C11.6235 14.2079 11.7864 14.2079 11.934 14.152L16.6632 12.3533V15.4859C16.6632 15.5272 16.6513 15.604 16.4611 15.7621C16.2709 15.9202 15.9207 16.1118 15.4641 16.2674C14.5509 16.5785 13.206 16.7794 11.7049 16.7794C10.2039 16.7794 8.85897 16.5785 7.94577 16.2674C7.48917 16.1118 7.13893 15.9202 6.94872 15.7621C6.7585 15.604 6.74661 15.5272 6.74661 15.4859V12.3533Z" fill={color} />
      </g>
    </svg>
  );
};
EducationBadgeIcon.defaultProps = defaultProps;
export default EducationBadgeIcon;
